<script setup>
import { useToast } from '~/composables/useToast';

const { toasts, removeToast } = useToast();
</script>

<template>
  <div class="toast-container position-fixed bottom-0 end-0 p-3">
    <PortalToastItem
      v-for="toast in toasts"
      :key="toast.id"
      :type="toast.type"
      :title="toast.title"
      :message="toast.message"
      :auto-hide="toast.autoHide"
      :delay="toast.delay"
      :visible="toast.visible"
      @hide="removeToast(toast.id)"
    />
  </div>
</template>
